module.exports = __webpack_public_path__ + "static/media/ball_2_3.bf4924df.mp3";